import { Autocomplete, ListSubheader, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const GroupListSubheader = styled(ListSubheader)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));
export const UnitLabelText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));
export const RateBaseAutocomplete = styled(Autocomplete)(({ theme }) => ({
  "&.MuiAutocomplete-hasPopupIcon>.MuiInputBase-root": {
    paddingLeft: theme.spacing(1),
    paddingRight: "28px",
  },
})) as typeof Autocomplete;
